import {cn} from '../../../../../../lib/utils.ts'
import {fieldVariants, fieldLabelClasses} from '../../../../../../components/general/fieldStyles.ts'

type ReferenceSectionProps = {
    poNumber: string
    onPoNumberChange: (value: string) => void
    customerReference: string
    onCustomerReferenceChange: (value: string) => void
    footerText: string
    onFooterTextChange: (value: string) => void
    defaultFooterText: string
    onSaveFooterTextAsDefault: () => void
    onResetFooterTextToDefault: () => void
    isSavingFooterText: boolean
}

export function ReferenceSection({
    poNumber,
    onPoNumberChange,
    customerReference,
    onCustomerReferenceChange,
    footerText,
    onFooterTextChange,
    defaultFooterText,
    onSaveFooterTextAsDefault,
    onResetFooterTextToDefault,
    isSavingFooterText,
}: ReferenceSectionProps) {
    const differsFromDefault = footerText.trim() !== defaultFooterText.trim()

    return (
        <section>
            <h2 className="text-xl font-bold">Referentie &amp; extra tekst</h2>
            <p className="text-xs text-gray-600 mt-1 mb-4">
                Grote klanten eisen vaak een PO-nummer of kenmerk op de factuur. Deze velden komen
                bovenaan de factuur te staan.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                    <label className={cn(fieldLabelClasses, 'mb-1')} htmlFor="po-number-input">
                        PO-nummer / referentie klant
                    </label>
                    <input
                        id="po-number-input"
                        className={cn(fieldVariants())}
                        value={poNumber}
                        onChange={(e) => onPoNumberChange(e.target.value)}
                        placeholder="Bijv. PO-4417 of kostenplaats 2200"
                    />
                </div>
                <div>
                    <label className={cn(fieldLabelClasses, 'mb-1')} htmlFor="customer-reference-input">
                        Klantspecifiek kenmerk
                    </label>
                    <input
                        id="customer-reference-input"
                        className={cn(fieldVariants())}
                        value={customerReference}
                        onChange={(e) => onCustomerReferenceChange(e.target.value)}
                        placeholder="Bijv. project Noordkade, t.a.v. afdeling Inkoop"
                    />
                </div>
            </div>
            <div className="mt-6">
                <div className="flex flex-wrap items-center justify-between gap-2 mb-1">
                    <label className={fieldLabelClasses} htmlFor="footer-text-input">
                        Vaste tekst op elke factuur
                    </label>
                    <div className="flex items-center gap-3">
                        {differsFromDefault && defaultFooterText.trim() !== '' && (
                            <button
                                type="button"
                                onClick={onResetFooterTextToDefault}
                                className="text-xs font-semibold text-primary hover:opacity-80"
                            >
                                Standaardtekst
                            </button>
                        )}
                        {differsFromDefault && (
                            <button
                                type="button"
                                onClick={onSaveFooterTextAsDefault}
                                disabled={isSavingFooterText}
                                className="text-xs font-semibold text-primary hover:opacity-80 disabled:opacity-50"
                            >
                                {isSavingFooterText ? 'Opslaan…' : 'Bewaar als standaardtekst'}
                            </button>
                        )}
                    </div>
                </div>
                <textarea
                    id="footer-text-input"
                    className={cn(fieldVariants({size: 'multi'}), 'px-3 py-2 min-h-16 resize-none')}
                    value={footerText}
                    onChange={(e) => onFooterTextChange(e.target.value)}
                    placeholder="Bijv. Betaling o.v.v. het factuurnummer. Op onze dienstverlening zijn onze algemene voorwaarden van toepassing."
                />
                <p className="mt-1 text-xs text-gray-500">
                    Deze tekst komt onderaan de factuur. Bewaar hem als standaardtekst om hem op elke
                    volgende factuur automatisch mee te nemen.
                </p>
            </div>
        </section>
    )
}
